module.exports = __webpack_public_path__ + "static/media/what-nodejs-can-do.40686a4e.md";